var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"content-class":"dialog-loader","persistent":""},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},[_c('div',[_c('ul',_vm._l((['A', 'B', 'C']),function(item,key){return _c('li',{key:key,staticClass:"primary",attrs:{"id":`dot${item}`}})}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }